import { FunctionComponent } from 'preact';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useIcons } from '../../hooks/useIcons';

export const QualityButton: FunctionComponent<IconButtonProps> = (props) => {
  const { List } = useIcons();

  return (
    <IconButton {...props}>
      <List />
    </IconButton>
  );
};
